import React from 'react';
import classnames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },
  inline: {
    display: 'inline-flex'
  },
  default: {
    backgroundColor: theme.palette.background.secondary,
    color: theme.palette.grey[500]
  },
  primary: {
    backgroundColor: theme.palette.primary.smoke,
    color: theme.palette.primary.main
  },
  success: {
    backgroundColor: theme.palette.success.smoke,
    color: theme.palette.success.main
  },
  error: {
    backgroundColor: theme.palette.error.smoke,
    color: theme.palette.error.main
  },
  warning: {
    backgroundColor: theme.palette.warning.smoke,
    color: theme.palette.warning.main
  },
  noBackground: {
    backgroundColor: 'transparent'
  },
  truncate: {
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  justifyContentLeft: {
    justifyContent: 'flex-start'
  },
  justifyContentCenter: {
    justifyContent: 'center'
  },
  justifyContentRight: {
    justifyContent: 'flex-end'
  },
  justifyContentBetween: {
    justifyContent: 'space-between'
  },
  justifyContentAround: {
    justifyContent: 'space-around'
  },
  alignItemsLeft: {
    alignItems: 'flex-end'
  },
  alignItemsCenter: {
    alignItems: 'center'
  },
  alignItemsRight: {
    alignItems: 'flex-start'
  },
  alignItemsBaseline: {
    alignItems: 'baseline'
  },
  alignItemsStretch: {
    alignItems: 'stretch'
  }
}));

export interface LabelProps {
  className?: string,
  title?: string,
  style?:
    | 'default'
    | 'primary'
    | 'success'
    | 'warning'
    | 'error',
  justifyContent?:
    | 'flex-start'
    | 'center'
    | 'flex-end'
    | 'space-between'
    | 'space-around'
  alignItems?:
    | 'flex-start'
    | 'center'
    | 'flex-end'
    | 'baseline'
    | 'stretch',
  inline?: boolean,
  truncate?: boolean,
  noBackground?: boolean
  children?: React.ReactNode
}

export function Label ({
  children,
  className: classNameProp,
  style = 'default',
  inline = false,
  truncate = false,
  justifyContent = 'space-between',
  alignItems = 'center',
  title,
  noBackground = false
}: LabelProps) {
  const classes = useStyles();

  const classNames = classnames(
    classes.root,
    {
      [classes.default]: style === 'default',
      [classes.primary]: style === 'primary',
      [classes.success]: style === 'success',
      [classes.error]: style === 'error',
      [classes.warning]: style === 'warning',
      [classes.inline]: inline,
      [classes.truncate]: truncate,
      [classes.justifyContentLeft]: justifyContent === 'flex-start',
      [classes.justifyContentCenter]: justifyContent === 'center',
      [classes.justifyContentRight]: justifyContent === 'flex-end',
      [classes.justifyContentBetween]: justifyContent === 'space-between',
      [classes.justifyContentAround]: justifyContent === 'space-around',
      [classes.alignItemsLeft]: alignItems === 'flex-start',
      [classes.alignItemsCenter]: alignItems === 'center',
      [classes.alignItemsRight]: alignItems === 'flex-end',
      [classes.alignItemsBaseline]: alignItems === 'baseline',
      [classes.alignItemsStretch]: alignItems === 'stretch',
      [classes.noBackground]: noBackground
    },
    classNameProp
  );

  return <span title={title} className={classNames}>{children}</span>;
}

export default Label;
